
import { UserRoomStateData, SubRoom } from '@/utils/models';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import StatusIcon from '@/components/room/users/StatusIcon.vue';
import RoomsMemberListItem from './RoomsMemberListItem.vue';
@Component({ components: { StatusIcon, RoomsMemberListItem } })
export default class RoomsMemberListItemBySubrooms extends Vue {
  @Prop() private subroom!: SubRoom;
  get current(): SubRoom {
    return this.subroom;
  }
  get members(): UserRoomStateData[] {
    return this.current?.userStates || [];
  }

  memberListOpened = false;
  toggleMemberList() {
    this.memberListOpened = !this.memberListOpened;
  }
}
